import { BaseService } from "../../Base/BaseService";
import { UserRole } from "../../globals";

export interface ILoginResponse {
  id: number;
  email: string;
  access_token: string;
  role: UserRole;
  isMaster: boolean;
  name: string;
  avatar_url: string;
  telegram: string;
  phone: string;
}

export class LoginService extends BaseService {
  public static async TryLogin(email: string, password: string): Promise<ILoginResponse> {
    const url = this.BaseApiUrl + `/auth/login`;

    const data = {
      email: email,
      password: password,
    };

    return this.post(url, data);
  }

  public static async GetUser(): Promise<ILoginResponse> {
    const url = this.BaseApiUrl + `/me`;

    return this.get(url);
  }
}
